import { formatCurrency } from "@gymflow/helpers";
import { WalletBalanceDTO } from "@gymflow/types";
import { useClubSettings } from "apps/portal/src/providers";
import { useTranslation } from "react-i18next";

import { Button, ChevronRightIcon } from "../../atoms";
import { WalletIconIcon } from "../../atoms/icons/WalletIcon";
import TopUpActionsMenuPopover from "./components/TopUpActionsMenuPopover";
import { UserMemberPaymentsCard } from "./UserMemberPaymentsCard";

type UserMemberWalletProps = {
  currentWalletBalance?: WalletBalanceDTO;
  link: string;
  memberId: string;
};

const UserMemberWallet = ({
  currentWalletBalance,
  link,
  memberId,
}: UserMemberWalletProps) => {
  const { t } = useTranslation();
  const {
    club: { defaultCurrency },
  } = useClubSettings();

  if (!currentWalletBalance) return null;

  return (
    <>
      <UserMemberPaymentsCard.Header>
        <div className="flex items-center gap-2">
          <div className="bg-secondary-50 dark:bg-secondary-500 flex size-9 items-center justify-center rounded-full">
            <WalletIconIcon pathClassName="stroke-secondary-700 dark:stroke-secondary-100" />
          </div>
          <div className="dark:text-gray-0 text-base font-semibold text-gray-950">
            {t("page.userWallets.walletCard.name")}
          </div>
        </div>
        <Button
          intent="transparent"
          className="flex flex-row items-center"
          link={link}
        >
          <div className="text-sm font-semibold text-gray-500">
            {t("page.userWallets.walletCard.history")}
          </div>
          <ChevronRightIcon pathClassName="stroke-gray-500" />
        </Button>
      </UserMemberPaymentsCard.Header>
      <UserMemberPaymentsCard.Footer footerClassName="items-end">
        <div className="dark:text-gray-0 text-2xl font-bold text-gray-950">
          {formatCurrency(
            currentWalletBalance?.walletBalance ?? 0,
            defaultCurrency,
          )}
        </div>
        <TopUpActionsMenuPopover memberId={memberId} />
      </UserMemberPaymentsCard.Footer>
    </>
  );
};

export default UserMemberWallet;
